import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from "@/views/auth/Login";
import cookies from 'vue-cookies'
import store from "@/store";
import ListOrganization from "@/views/Organization/ListOrganization";
import ListUser from "@/views/users/ListUser";
import process_map from "@/views/process/process_map";
import process_id from "@/views/process/proccess_id/process_id.vue";
import process_documentation_managementView from "@/views/process/process_documentation_management/process_documentation_managementView.vue";
import beneficiary_id from "@/views/beneficiary/beneficiary_id";
import beneficiary_map from "@/views/beneficiary/beneficiary_map";
import beneficiary_id_order_by from "@/views/beneficiary/beneficiary_id_order_by";
import process_map_print from "@/views/process/process_map_print.vue";
import process_list_id from "@/views/process/proccess_id/process_list_id.vue";
import definitions from "@/views/Financial_management_and_productivity/basic/definitions.vue";
import FaceDefinitionFinancialSituation
    from "@/views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituation.vue";
import ProfitAndLossStructure
    from "@/views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructure.vue";
import TheStructureOfTheCashFlowStatement
    from "@/views/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/TheStructureOfTheCashFlowStatement.vue";
import DefinitionOfOutput
    from "@/views/Financial_management_and_productivity/DefinitionOfOutput/DefinitionOfOutput.vue";
import DefinitionOfConsequence
    from "@/views/Financial_management_and_productivity/DefinitionOfConsequence/DefinitionOfConsequence.vue";
import DefinitionOfEffect
    from "@/views/Financial_management_and_productivity/DefinitionOfEffect/DefinitionOfEffect.vue";
import FaceDefinitionFinancialSituationChart
    from "@/views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationChart.vue";
import ProfitAndLossStructureChart
    from "@/views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureChart.vue";
import IntermediateOutcome
    from "@/views/Financial_management_and_productivity/IntermediateOutcome/IntermediateOutcome.vue";
import functional_informationView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/functional_informationView.vue";
import budget_informationView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/budget_informationView.vue";
import functional_information_FinancialView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_FinancialView.vue";
import functional_information_receivedView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_receivedView.vue";
import functional_information_ConsequencesView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_ConsequencesView.vue";
import functional_information_effectView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_effectView.vue";
import functional_information_Consequences_middleView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_Consequences_middleView.vue";
import budget_information_FinancialView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_FinancialView.vue";
import budget_information_receivedView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_receivedView.vue";
import budget_information_ConsequencesView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_ConsequencesView.vue";
import budget_information_Consequences_middleView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_Consequences_middleView.vue";
import budget_information_effectView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_effectView.vue";
import functional_information_wealths
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_wealths.vue";
import functional_information_debts
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_debts.vue";
import functional_information_cashes
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_cashes.vue";
import budget_information_wealths
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_wealths.vue";
import budget_information_debts
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_debts.vue";
import budget_information_profitAndLossStructures
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_profitAndLossStructures.vue";
import budget_information_cashes
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_cashes.vue";
import functional_information_profitAndLossStructures
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_profitAndLossStructures.vue";
import Problem_identification from "@/views/problem_analysis/Problem_identification/Problem_identification.vue";
import Prioritizing_issue from "@/views/problem_analysis/Prioritizing_issue/Prioritizing_issue.vue";
import The_root_causes_of_the_problem
    from "@/views/problem_analysis/The_root_causes_of_the_problem/The_root_causes_of_the_problem.vue";
import Definition_of_basic_measures
    from "@/views/problem_analysis/Definition_of_basic_measures/Definition_of_basic_measures.vue";
import Determining_the_mission
    from "@/views/Financial_management_and_productivity/Determining_the_mission/Determining_the_mission.vue";
import Definition_of_basic_measures_SupportMeasures
    from "@/views/problem_analysis/Definition_of_basic_measures/Definition_of_basic_measures_SupportMeasures.vue";
import device_monitoring_and_care
    from "@/views/problem_analysis/device_monitoring_and_care/device_monitoring_and_care.vue";
import ListMothersItems from "@/views/users/mother/ListMothersItems.vue";
import ListUserMotherById from "@/views/users/mother/ListUserMotherById.vue";
import ListOrganizationById from "@/views/Organization/ListOrganizationById.vue";
import process_map_by_id from "@/views/process/process_map_by_id.vue";
import process_list_id_by_id from "@/views/process/proccess_id/process_list_id_by_id.vue";
import process_id_by_mother from "@/views/process/proccess_id/process_id_by_mother.vue";
import job_evaluation from "@/views/process/evaluation/job_evaluation.vue";
import process_documentation_managementByIdView
    from "@/views/process/process_documentation_management/process_documentation_managementByIdView.vue";
import beneficiary_map_by_id from "@/views/beneficiary/beneficiary_map_by_id.vue";
import definitions_by_id from "@/views/Financial_management_and_productivity/basic/definitions_by_id.vue";
import FaceDefinitionFinancialSituationChartById
    from "@/views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationChartById.vue";
import FaceDefinitionFinancialSituationById
    from "@/views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationById.vue";
import ProfitAndLossStructureById
    from "@/views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureById.vue";
import ProfitAndLossStructureChartById
    from "@/views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureChartById.vue";
import TheStructureOfTheCashFlowStatementById
    from "@/views/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/TheStructureOfTheCashFlowStatementById.vue";
import DefinitionOfOutputById
    from "@/views/Financial_management_and_productivity/DefinitionOfOutput/DefinitionOfOutputById.vue";
import DefinitionOfConsequenceById
    from "@/views/Financial_management_and_productivity/DefinitionOfConsequence/DefinitionOfConsequenceById.vue";
import IntermediateOutcomeById
    from "@/views/Financial_management_and_productivity/IntermediateOutcome/IntermediateOutcomeById.vue";
import DefinitionOfEffectById
    from "@/views/Financial_management_and_productivity/DefinitionOfEffect/DefinitionOfEffectById.vue";
import functional_informationByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/functional_informationByIdView.vue";
import functional_information_FinancialByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_FinancialByIdView.vue";
import functional_information_receivedByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_receivedByIdView.vue";
import functional_information_ConsequencesByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_ConsequencesByIdView.vue";
import functional_information_Consequences_middleByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_Consequences_middleByIdView.vue";
import functional_information_effectByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_effectByIdView.vue";
import functional_information_wealthsById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_wealthsById.vue";
import functional_information_debtsById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_debtsById.vue";
import functional_information_profitAndLossStructuresById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_profitAndLossStructuresById.vue";
import functional_information_cashesById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_cashesById.vue";
import budget_informationByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/budget_informationByIdView.vue";
import budget_information_FinancialByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_FinancialByIdView.vue";
import budget_information_receivedByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_receivedByIdView.vue";
import budget_information_ConsequencesByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_ConsequencesByIdView.vue";
import budget_information_Consequences_middleByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_Consequences_middleByIdView.vue";
import budget_information_effectByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_effectByIdView.vue";
import budget_information_wealthsById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_wealthsById.vue";
import budget_information_debtsById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_debtsById.vue";
import budget_information_profitAndLossStructuresById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_profitAndLossStructuresById.vue";
import budget_information_cashesById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_cashesById.vue";
import Determining_the_missionById
    from "@/views/Financial_management_and_productivity/Determining_the_mission/Determining_the_missionById.vue";
import Problem_identificationById from "@/views/problem_analysis/Problem_identification/Problem_identificationById.vue";
import Prioritizing_issueById from "@/views/problem_analysis/Prioritizing_issue/Prioritizing_issueById.vue";
import The_root_causes_of_the_problemById
    from "@/views/problem_analysis/The_root_causes_of_the_problem/The_root_causes_of_the_problemById.vue";
import Definition_of_basic_measuresById
    from "@/views/problem_analysis/Definition_of_basic_measures/mother/Definition_of_basic_measuresById.vue";
import Definition_of_basic_measures_SupportMeasuresById
    from "@/views/problem_analysis/Definition_of_basic_measures/mother/Definition_of_basic_measures_SupportMeasuresById.vue";
import device_monitoring_and_careById
    from "@/views/problem_analysis/device_monitoring_and_care/device_monitoring_and_careById.vue";
import process_documentation_managementFolderModeView
    from "@/views/process/process_documentation_management/process_documentation_managementFolderMode/process_documentation_managementFolderModeView.vue";
import Process_documentation_managementFolderModeAndFileView
    from "@/views/process/process_documentation_management/process_documentation_managementFolderMode/process_documentation_managementFolderModeAndFileView.vue";
 import process_map_self from "@/views/process/process_map_self.vue";
import job_evaluation_by_id from "@/views/process/evaluation/job_evaluation_by_id.vue";
import job_evaluation_self from "@/views/process/evaluation/job_evaluation_self.vue";
import ListUserSelf from "@/views/users/mother/ListUserSelf.vue";
import ListOrganizationSelf from "@/views/Organization/ListOrganizationSelf.vue";
import settingsView from "@/views/settings/SettingsView.vue";
import SettingsUnitsView from "@/views/settings/SettingsUnitsView.vue";
import ListMothersItemsExports from "@/views/users/mother/ListMothersItemsExports.vue";

const routes = [
    // mother
    {
        path: '/mother_items',
        name: 'mother_items',
        component: ListMothersItems,
        meta: {requiredAuth: true}


    }, {
        path: '/mother_items_export',
        name: 'mother_items_export',
        component: ListMothersItemsExports,
        meta: {requiredAuth: true}


    },
    // pishkhan
    {
        path: '/pishkhan',
        name: 'home',
        component: HomeView,
        meta: {requiredAuth: true}


    },
//    user **************************************************

    {
        path: '/pishkhan/list/user',
        name: 'list_user',
        component: ListUser,
        meta: {requiredAuth: true}


    },
    {
        path: '/pishkhan/list/user_self',
        name: 'list_user_self',
        component: ListUserSelf,
        meta: {requiredAuth: true}


    },
    {
        path: '/pishkhan/list/user/by/:id/:title',
        name: 'list_user_mother',
        component: ListUserMotherById,
        meta: {requiredAuth: true}


    },
    {
        path: '/pishkhan/Organization/list',
        name: 'list_organic',
        component: ListOrganization,
        meta: {requiredAuth: true}


    },
    {
        path: '/pishkhan/Organization/list_self',
        name: 'list_organic_self',
        component: ListOrganizationSelf,
        meta: {requiredAuth: true}


    },
    {
        path: '/pishkhan/Organization/list/by/:id/:title',
        name: 'list_organic_mother',
        component: ListOrganizationById,
        meta: {requiredAuth: true}


    },
//  auth   **************************************************

    {
        path: '/',
        name: 'login',
        component: Login,
        meta: {loginRedirect: true}

    },
    // process
//     **************************************************

    {
        path: '/process/map',
        name: 'process_map',
        component: process_map,
        meta: {requiredAuth: true}

    }, {
        path: '/process/map_self',
        name: 'process_map_self',
        component: process_map_self,
        meta: {requiredAuth: true}

    },
    {
        path: '/process/map/by/:id/:title',
        name: 'process_map_by_id',
        component: process_map_by_id,
        meta: {requiredAuth: true}

    },
    {
        path: '/process/map/print',
        name: 'process_map_print',
        component: process_map_print,
        meta: {requiredAuth: true}

    },

    {
        path: '/process/id',
        name: 'process_id',
        component: process_list_id,
        meta: {requiredAuth: true}

    },
    {
        path: '/process/id/by/:id/:title',
        name: 'process_id_by_id',
        component: process_list_id_by_id,
        meta: {requiredAuth: true}

    },
    {
        path: '/process/id/complete/:id',
        name: 'process_id_complete',
        component: process_id,
        meta: {requiredAuth: true},


    },
    {
        path: '/process/id/complete/by_mother/:id/:title',
        name: 'process_id_complete_by_mother',
        component: process_id_by_mother,
        meta: {requiredAuth: true},


    },
    {
        path: '/settings',
        name: 'settings',
        component: settingsView,
        meta: {requiredAuth: true},


    },
    {
        path: '/settings/units',
        name: 'settings_units',
        component: SettingsUnitsView,
        meta: {requiredAuth: true},


    },
    {
        path: '/job/evaluation',
        name: 'job_evaluation',
        component: job_evaluation,
        meta: {requiredAuth: true},


    },
    {
        path: '/job/evaluation/by/:id/:title',
        name: 'job_evaluation_by_id',
        component: job_evaluation_by_id,
        meta: {requiredAuth: true},


    },
    {
        path: '/job/evaluation/by/self',
        name: 'job_evaluation_by_self',
        component: job_evaluation_self,
        meta: {requiredAuth: true},


    },
    {
        path: '/Process/documentation/management',
        name: 'process_documentation_management',
        component: process_documentation_managementView,
        meta: {requiredAuth: true},


    },
    {
        path: '/Process/documentation/management/FolderMode',
        name: 'process_documentation_management_FolderMode',
        component: process_documentation_managementFolderModeView,
        meta: {requiredAuth: true},


    },
    {
        path: '/Process/documentation/management/FolderAndFileMode/:id',
        name: 'process_documentation_management_FolderAndFileMode',
        component: Process_documentation_managementFolderModeAndFileView,
        meta: {requiredAuth: true},


    },
    {
        path: '/Process/documentation/management/by/:id/:title',
        name: 'process_documentation_management_by_id',
        component: process_documentation_managementByIdView,
        meta: {requiredAuth: true},


    },
//     **************************************************

    //Beneficiary
    {
        path: '/beneficiary/map',
        name: 'beneficiary_map',
        component: beneficiary_map,
        meta: {requiredAuth: true}

    },
    {
        path: '/beneficiary/map/by/:id/:title',
        name: 'beneficiary_map_by_id',
        component: beneficiary_map_by_id,
        meta: {requiredAuth: true}

    },
    {
        path: '/beneficiary/id',
        name: 'beneficiary_id',
        component: beneficiary_id,
        meta: {requiredAuth: true}

    },
    {
        path: '/beneficiary/order_by',
        name: 'beneficiary_id_order_by',
        component: beneficiary_id_order_by,
        meta: {requiredAuth: true}

    },
//    Financial management and productivity **************************************************
    {
        path: '/Financial_management_and_productivity/definitions',
        name: 'Financial_management_and_productivity_definitions',
        component: definitions,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/definitions/by/:id/:title',
        name: 'Financial_management_and_productivity_definitions_by',
        component: definitions_by_id,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/Determining_the_mission',
        name: 'Financial_management_and_productivity_Determining_the_mission',
        component: Determining_the_mission,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/Determining_the_mission/By/:id/:title',
        name: 'Financial_management_and_productivity_Determining_the_missionById',
        component: Determining_the_missionById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/FaceDefinitionFinancialSituation',
        name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation',
        component: FaceDefinitionFinancialSituation,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/FaceDefinitionFinancialSituation/by/:id/:title',
        name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_by_id',
        component: FaceDefinitionFinancialSituationById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/FaceDefinitionFinancialSituation/chart',
        name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_chart',
        component: FaceDefinitionFinancialSituationChart,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/FaceDefinitionFinancialSituation/chart/by/:id/:title',
        name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_chart_by_id',
        component: FaceDefinitionFinancialSituationChartById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/ProfitAndLossStructure',
        name: 'Financial_management_and_productivity_ProfitAndLossStructure',
        component: ProfitAndLossStructure,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/ProfitAndLossStructure/by/:id/:title',
        name: 'Financial_management_and_productivity_ProfitAndLossStructure_by_id',
        component: ProfitAndLossStructureById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/ProfitAndLossStructure/chart',
        name: 'Financial_management_and_productivity_ProfitAndLossStructure_chart',
        component: ProfitAndLossStructureChart,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/ProfitAndLossStructure/chart/by/:id/:title',
        name: 'Financial_management_and_productivity_ProfitAndLossStructure_chart_by_id',
        component: ProfitAndLossStructureChartById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement',
        name: 'Financial_management_and_productivity_TheStructureOfTheCashFlowStatement',
        component: TheStructureOfTheCashFlowStatement,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/by/:id/:title',
        name: 'Financial_management_and_productivity_TheStructureOfTheCashFlowStatement_by_id',
        component: TheStructureOfTheCashFlowStatementById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfOutput',
        name: 'Financial_management_and_productivity_DefinitionOfOutput',
        component: DefinitionOfOutput,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfOutput/by/:id/:title',
        name: 'Financial_management_and_productivity_DefinitionOfOutput_by_id',
        component: DefinitionOfOutputById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfConsequence',
        name: 'Financial_management_and_productivity_DefinitionOfConsequence',
        component: DefinitionOfConsequence,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfConsequence/by/:id/:title',
        name: 'Financial_management_and_productivity_DefinitionOfConsequenceById',
        component: DefinitionOfConsequenceById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/IntermediateOutcome',
        name: 'Financial_management_and_productivity_IntermediateOutcome',
        component: IntermediateOutcome,
        meta: {requiredAuth: true}

    },    {
        path: '/Financial_management_and_productivity/IntermediateOutcome/by/:id/:title',
        name: 'Financial_management_and_productivity_IntermediateOutcomeById',
        component: IntermediateOutcomeById,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfEffect',
        name: 'Financial_management_and_productivity_DefinitionOfEffect',
        component: DefinitionOfEffect,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfEffect/by/:id/:title',
        name: 'Financial_management_and_productivity_DefinitionOfEffectById',
        component: DefinitionOfEffectById,
        meta: {requiredAuth: true}

    },
    // functional_informationView
    {
        path: '/Financial_management_and_productivity/functional_information',
        name: 'Financial_management_and_productivity_functional_information',
        component: functional_informationView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_informationById',
        component: functional_informationByIdView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/Financial',
        name: 'Financial_management_and_productivity_functional_information_Financial',
        component: functional_information_FinancialView,
        meta: {requiredAuth: true},
    },

    {
        path: '/Financial_management_and_productivity/functional_information/Financial/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_FinancialById',
        component: functional_information_FinancialByIdView,
        meta: {requiredAuth: true},
    },


    {
        path: '/Financial_management_and_productivity/functional_information/received',
        name: 'Financial_management_and_productivity_functional_information_received',
        component: functional_information_receivedView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/received/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_received_by_id',
        component: functional_information_receivedByIdView,
        meta: {requiredAuth: true},
    },

    {
        path: '/Financial_management_and_productivity/functional_information/Consequences',
        name: 'Financial_management_and_productivity_functional_information_Consequences',
        component: functional_information_ConsequencesView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/Consequences/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_ConsequencesById',
        component: functional_information_ConsequencesByIdView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/Consequences/middle',
        name: 'Financial_management_and_productivity_functional_information_Consequences_middle',
        component: functional_information_Consequences_middleView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/Consequences/middle/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_Consequences_middle_by_id',
        component: functional_information_Consequences_middleByIdView,
        meta: {requiredAuth: true},
    },

    {
        path: '/Financial_management_and_productivity/functional_information/effect/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_effectById',
        component: functional_information_effectByIdView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/wealths',
        name: 'Financial_management_and_productivity_functional_information_wealths',
        component: functional_information_wealths,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/wealths/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_wealthsById',
        component: functional_information_wealthsById,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/debts',
        name: 'Financial_management_and_productivity_functional_information_debts',
        component: functional_information_debts,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/debts/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_debtsById',
        component: functional_information_debtsById,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/profit_and_loss_structures',
        name: 'Financial_management_and_productivity_functional_information_profitAndLossStructures',
        component: functional_information_profitAndLossStructures,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/profit_and_loss_structures/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_profitAndLossStructuresById',
        component: functional_information_profitAndLossStructuresById,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/cashes',
        name: 'Financial_management_and_productivity_functional_information_cashes',
        component: functional_information_cashes,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/cashes/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_cashesById',
        component: functional_information_cashesById,
        meta: {requiredAuth: true},
    },
    // budget_informationView
    {
        path: '/Financial_management_and_productivity/budget_information',
        name: 'Financial_management_and_productivity_budget_information',
        component: budget_informationView,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/budget_information/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_informationById',
        component: budget_informationByIdView,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/budget_information/Financial',
        name: 'Financial_management_and_productivity_budget_information_Financial',
        component: budget_information_FinancialView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Financial/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_FinancialById',
        component: budget_information_FinancialByIdView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/received',
        name: 'Financial_management_and_productivity_budget_information_received',
        component: budget_information_receivedView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/received/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_receivedById',
        component: budget_information_receivedByIdView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Consequences/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_ConsequencesById',
        component: budget_information_ConsequencesByIdView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Consequences',
        name: 'Financial_management_and_productivity_budget_information_Consequences',
        component: budget_information_ConsequencesView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Consequences/middle/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_Consequences_middleById',
        component: budget_information_Consequences_middleByIdView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Consequences/middle',
        name: 'Financial_management_and_productivity_budget_information_Consequences_middle',
        component: budget_information_Consequences_middleView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/effect/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_effectById',
        component: budget_information_effectByIdView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/effect',
        name: 'Financial_management_and_productivity_budget_information_effect',
        component: budget_information_effectView,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/wealths/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_wealthsById',
        component: budget_information_wealthsById,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/wealths',
        name: 'Financial_management_and_productivity_budget_information_wealths',
        component: budget_information_wealths,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/debts/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_debtsById',
        component: budget_information_debtsById,
        meta: {requiredAuth: true},
    },

    {
        path: '/Financial_management_and_productivity/budget_information/debts',
        name: 'Financial_management_and_productivity_budget_information_debts',
        component: budget_information_debts,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/profit_and_loss_structures',
        name: 'Financial_management_and_productivity_budget_information_profitAndLossStructures',
        component: budget_information_profitAndLossStructures,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/profit_and_loss_structures/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_profitAndLossStructuresById',
        component: budget_information_profitAndLossStructuresById,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/cashes',
        name: 'Financial_management_and_productivity_budget_information_cashes',
        component: budget_information_cashes,
        meta: {requiredAuth: true},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/cashes/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_cashesById',
        component: budget_information_cashesById,
        meta: {requiredAuth: true},
    },
    //problem analysis
    {
        path: '/problem_analysis/Problem_identification',
        name: 'problem_analysis_Problem_identification',
        component: Problem_identification,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Problem_identification/by/:id/:title',
        name: 'problem_analysis_Problem_identificationById',
        component: Problem_identificationById,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Prioritizing_issue',
        name: 'problem_analysis_Prioritizing_issue',
        component: Prioritizing_issue,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Prioritizing_issue/by/:id/:title',
        name: 'problem_analysis_Prioritizing_issueById',
        component: Prioritizing_issueById,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/The_root_causes_of_the_problem',
        name: 'problem_analysis_The_root_causes_of_the_problem',
        component: The_root_causes_of_the_problem,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/The_root_causes_of_the_problem/by/:id/:title',
        name: 'problem_analysis_The_root_causes_of_the_problemById',
        component: The_root_causes_of_the_problemById,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Definition_of_basic_measures',
        name: 'problem_analysis_Definition_of_basic_measures',
        component: Definition_of_basic_measures,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Definition_of_basic_measures/by/:id/:title',
        name: 'problem_analysis_Definition_of_basic_measuresById',
        component: Definition_of_basic_measuresById,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Definition_of_basic_measures/SupportMeasures',
        name: 'problem_analysis_Definition_of_basic_measures_SupportMeasures',
        component: Definition_of_basic_measures_SupportMeasures,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Definition_of_basic_measures/SupportMeasures/by/:id/:title',
        name: 'problem_analysis_Definition_of_basic_measures_SupportMeasuresById',
        component: Definition_of_basic_measures_SupportMeasuresById,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/device_monitoring_and_care',
        name: 'problem_analysis_device_monitoring_and_care',
        component: device_monitoring_and_care,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/device_monitoring_and_care/by/:id/:title',
        name: 'problem_analysis_device_monitoring_and_careById',
        component: device_monitoring_and_careById,
        meta: {requiredAuth: true},
    },


]

const router = createRouter({
    history: createWebHistory(),
    routes
})
router.beforeEach((to, from, next) => {


    if (to.matched.some(record => record.meta.requiredAuth)) {
        if (cookies.isKey('token')) {
            next()
        } else {
            next('/')
        }


    }
    else if (to.matched.some(record => record.meta.loginRedirect)) {
        if (!cookies.isKey('token')) {
            next();
        } else {
            next('/pishkhan');
        }
    } else {
        next()
    }


})

export default router
